import apiClient from './api';

const adminService = {
    // Stats
    getDashboardStats: async () => {
        const response = await apiClient.get('/admin/stats');
        return response.data;
    },

    // Packages
    getAllPackages: (params) => apiClient.get('/admin/packages', { params }).then(res => res.data),
    createPackage: (data) => apiClient.post('/admin/packages', data).then(res => res.data),
    updatePackage: (id, updates) => apiClient.put(`/admin/packages/${id}`, updates).then(res => res.data),
    deletePackage: (id) => apiClient.delete(`/admin/packages/${id}`).then(res => res.data),

    // Promotions
    getPromotions: (params) => apiClient.get('/admin/promotions', { params }).then(res => res.data),
    createPromotion: (data) => apiClient.post('/admin/promotions', data).then(res => res.data),
    updatePromotion: (id, data) => apiClient.put(`/admin/promotions/${id}`, data).then(res => res.data),
    deletePromotion: (id) => apiClient.delete(`/admin/promotions/${id}`).then(res => res.data),

    // Users
    getAllUsers: (params) => apiClient.get('/admin/users', { params }).then(res => res.data),
    toggleUserStatus: (id, isActive) => apiClient.put(`/admin/users/${id}/status`, { isActive }).then(res => res.data),
    updateUser: (id, data) => apiClient.put(`/admin/users/${id}`, data).then(res => res.data),
    deleteUser: (id) => apiClient.delete(`/admin/users/${id}`).then(res => res.data),

    // Orders
    getAllOrders: (params) => apiClient.get('/admin/orders', { params }).then(res => res.data),
    updateOrderStatus: (id, status) => apiClient.put(`/admin/orders/${id}/status`, { status }).then(res => res.data),
    deleteOrder: (id) => apiClient.delete(`/admin/orders/${id}`).then(res => res.data),

    // Subscriptions
    getSubscriptions: (params) => apiClient.get('/admin/subscriptions', { params }).then(res => res.data),
    createSubscription: (data) => apiClient.post('/admin/subscriptions', data).then(res => res.data),
    updateSubscription: (id, data) => apiClient.put(`/admin/subscriptions/${id}`, data).then(res => res.data),
    deleteSubscription: (id) => apiClient.delete(`/admin/subscriptions/${id}`).then(res => res.data),

    // Transactions
    getTransactions: (params) => apiClient.get('/admin/transactions', { params }).then(res => res.data),
    deleteTransaction: (id) => apiClient.delete(`/admin/transactions/${id}`).then(res => res.data),
};

export default adminService;
